import { uuid } from "vue-uuid"; 

import service from "@/libs/service";

export const namespaced = true;

export const state = {
    sessionId: null,
    userId: null,
    update: false,
    activities: []
};

export const mutations = {
    SET_COOKIES(state, content) {
        if (content.activities)
            state.activities = content.activities;
        
        if (content.session)
            state.session = content.session;
    }
};

export const actions = {
    activity({ state, rootState, dispatch }, activity) {
        let session = rootState.users;
        let logout = false;

        /// Logica de session ///
        if (state.userId) {
            if (!session.user) {
                logout = true;   
            }
        } else {
            if (session.user && session.user.id > 0) {
                if (!state.userId)
                    state.update = true;
                state.userId = session.user.id;
            }
        }

        if (!state.sessionId) {
            state.sessionId = uuid.v1();
        }

        state.activities.push(activity);
        dispatch("flush");
        if (state.activities.length >= process.env.VUE_APP_ACTIVITY_QUEUE_LENGTH || logout) {
            service.request("/activity", Object.assign({}, state)).then(() => {
                state.activities = [];
                state.update = false;
                dispatch("flush");
            });
        }

        if (logout) {
            state.userId = null;
            state.sessionId = null;
            state.activities = [];
            state.update = false;
            dispatch("flush");
        }
    },
    flush({ state }) {
        localStorage.setItem("cookies", JSON.stringify(state));
    }
};

export const getters = {
};
